/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HospitalMessage } from './HospitalMessage';
import {
    HospitalMessageFromJSON,
    HospitalMessageFromJSONTyped,
    HospitalMessageToJSON,
} from './HospitalMessage';

/**
 * 
 * @export
 * @interface CreateHospitalMessageSync200Response
 */
export interface CreateHospitalMessageSync200Response {
    /**
     * 
     * @type {HospitalMessage}
     * @memberof CreateHospitalMessageSync200Response
     */
    data?: HospitalMessage;
}

/**
 * Check if a given object implements the CreateHospitalMessageSync200Response interface.
 */
export function instanceOfCreateHospitalMessageSync200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateHospitalMessageSync200ResponseFromJSON(json: any): CreateHospitalMessageSync200Response {
    return CreateHospitalMessageSync200ResponseFromJSONTyped(json, false);
}

export function CreateHospitalMessageSync200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateHospitalMessageSync200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : HospitalMessageFromJSON(json['data']),
    };
}

export function CreateHospitalMessageSync200ResponseToJSON(value?: CreateHospitalMessageSync200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': HospitalMessageToJSON(value.data),
    };
}

